<ndt-schedule-detail-view
   [schedule]="schedule$ | async"
   [schedulePrivileges]="schedulePrivileges$ | async"
   [callState]="callState$ | async"
   [isSystemUser]="isSystemUser$ | async"
   [selectedAccountName]="selectedAccount$ | async"
   (formSaveCanceled)="onFormSaveCanceled()"
   (deleteSchedule)="onDeleteSchedule($event)"
   (formSubmitted)="onFormSubmitted($event)"
   (addScheduleHour)="onAddScheduleHour()"
   (addClosedException)="onAddClosedException()"
></ndt-schedule-detail-view>
